/**
 * Registry of all dynamic configs used in the application.
 * To add a new config, add an entry to this map.
 */
import ONBOARDING_TUTORIAL_GUIDS, {
  ONBOARDING_VIDEO_TRACK_GUID,
} from "@/consts/onboardingTutorials";

export const CONFIGS: Record<string, DynamicConfigOptions> = {
  REVUP_CAMPAIGN: {
    configName: "revupguids",
    fallback: {
      REV_UP_CAMPAIGN_GUIDs: [],
      REV_UP_CAMPAIGN_START: "",
      REV_UP_CAMPAIGN_END: "",
    },
  },
  PROMOTION_BANNER: {
    configName: "content_overview_promo_banner",
    fallback: {},
  },
  SJC_OUTAGE: {
    configName: "sjc_outage",
    fallback: {
      SJC_OUTAGE_GUIDs: [],
      SJC_OUTAGE_START: "",
      SJC_OUTAGE_END: "",
    },
  },
  ILT_BLADE: {
    configName: "ilt_blade_guid_exceptions",
    fallback: {
      ILT_BLADE_EXCLUDED_PATH_GUIDS: [
        "77c61584-9416-48c0-b83d-bdcc725ea4c6",
        "ff8bfeb0-0f11-4750-b270-abc5754d1a0a",
      ],
      ILT_BLADE_INCLUDED_PATH_GUIDS: ["660d6fde-4004-411f-bd42-abe661f49fa7"],
    },
  },
  OTSEC_ANNOUNCEMENT: {
    configName: "OTSecGuids",
    fallback: {
      OTSEC_GUIDs: [],
      OTSEC_START: "",
      OTSEC_END: "",
    },
  },
  GET_STARTED_CAROUSEL: {
    configName: "get_started_carousel",
    // The carousel currently supports one video series currently because it fetches one /tracks response.
    fallback: {
      ONBOARDING_TUTORIAL_GUIDS,
      ONBOARDING_VIDEO_TRACK_GUID,
    },
  },
};

export interface DynamicConfigOptions {
  configName: string;
  fallback: Record<string, unknown>;
}

export type ConfigKey = keyof typeof CONFIGS;
